import { createFileRoute } from '@tanstack/react-router';
import Availability from '~/containers/Availability';

export const Route = createFileRoute('/availability/')({
  validateSearch(search) {
    return {
      from: (search.from as string) || undefined,
      publisherId: (search.publisherId as string) || undefined,
    };
  },
  component: Availability,
});
